import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getHeaderSidBarNovo, limparSessao } from '../../services/authentication/auth';

export default function ForceLogout({ redirectTo = '' }) {
  const navigate = useNavigate();

  useEffect(() => {
    const sessionHeaderNovo = !!getHeaderSidBarNovo();
    if (sessionHeaderNovo || redirectTo === 'login') {
      limparSessao();
      navigate('/login');
      return;
    }

    limparSessao();

    let dominioURL = 'one7';
    if (window && window.location.hostname !== 'localhost') {
      const hostnameParts = window.location.hostname.split('.');
      hostnameParts.shift();
      dominioURL = hostnameParts.join('.');
    }

    const endDomain =
      process.env.REACT_APP_PLATAFORMA_DIGITAL_ENDDOMAIN !== undefined
        ? process.env.REACT_APP_PLATAFORMA_DIGITAL_ENDDOMAIN
        : '';
    const subDomain =
      process.env.REACT_APP_PLATAFORMA_DIGITAL_SUBDOMAIN !== undefined &&
      process.env.REACT_APP_PLATAFORMA_DIGITAL_SUBDOMAIN !== ''
        ? `${process.env.REACT_APP_PLATAFORMA_DIGITAL_SUBDOMAIN}.`
        : dominioURL === 'parceiro.one7.app'
          ? 'digital.'
          : '';

    window.location.replace(`${window.location.protocol}//${subDomain}${dominioURL}${endDomain}/#/`);
  }, []);

  return <div style={{ height: '1000px' }} />;
}
